import React, { useState } from 'react';
import styled from '@emotion/styled';
import ChapterSidebar from './ChapterSidebar';

const SidebarTabBar = styled.div`
  display: flex;
  background: var(--midWhite);
  border-radius: 5px 5px 0 0;
  overflow: hidden;
`;

const SidebarTab = styled.button`
  flex: 1;
  border: 0;
  background: ${props => (props.active ? 'var(--midWhite)' : 'transparent')};
  color: ${props => (props.active ? 'var(--sapGreen)' : 'var(--greyBlue)')};
  font-size: 10px;
  font-weight: ${props => (props.active ? 700 : 500)};
  letter-spacing: 0.08rem;
  text-transform: uppercase;
  padding: 10px 8px;
  cursor: pointer;
  border-bottom: 2px solid ${props => (props.active ? 'var(--sapGreen)' : 'transparent')};
`;

const columnStyle = fullScreen => ({
  height: fullScreen ? '100%' : 'auto',
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column'
});

export default function ChapterLeftColumn({
  layout = 'tabs',
  fullScreen = false,
  chapters = [],
  currentTime = '',
  onChapterClick = () => {},
  captureGuide
}) {
  const [leftSidebarTab, setLeftSidebarTab] = useState('chapters');
  const compact = layout === 'stacked';
  const guide = captureGuide
    ? React.cloneElement(captureGuide, { compact, asColumn: false, fullScreen })
    : null;

  if (layout === 'underPlayer' || layout === 'rightCards') {
    return (
      <div className="col-md-3" style={columnStyle(fullScreen)}>
        {guide}
      </div>
    );
  }

  if (layout === 'stacked') {
    return (
      <div className="col-md-3" style={{ ...columnStyle(fullScreen), gap: 8 }}>
        <ChapterSidebar
          chapters={chapters}
          currentTime={currentTime}
          onChapterClick={onChapterClick}
          fullScreen={fullScreen}
          compact
          asColumn={false}
        />
        {guide}
      </div>
    );
  }

  return (
    <div className="col-md-3" style={columnStyle(fullScreen)}>
      <SidebarTabBar>
        <SidebarTab type="button" active={leftSidebarTab === 'chapters'} onClick={() => setLeftSidebarTab('chapters')}>
          Chapters
        </SidebarTab>
        <SidebarTab type="button" active={leftSidebarTab === 'guide'} onClick={() => setLeftSidebarTab('guide')}>
          Capture Guide
        </SidebarTab>
      </SidebarTabBar>
      {leftSidebarTab === 'chapters' ? (
        <ChapterSidebar
          chapters={chapters}
          currentTime={currentTime}
          onChapterClick={onChapterClick}
          fullScreen={fullScreen}
          asColumn={false}
        />
      ) : (
        guide
      )}
    </div>
  );
}
